/**
 * Hour Slot Components for Week and Day Views
 * Droppable slots for time-based scheduling
 */
import { useDroppable } from "@dnd-kit/core";
import { format } from "date-fns";
import { DraggableEvent } from "./DraggableEvent";

export const WeekHourSlot = ({ date, hour, events, onEventClick, onSlotClick }) => {
  const dateStr = `${format(date, "yyyy-MM-dd")}-${hour}`;
  const { isOver, setNodeRef } = useDroppable({
    id: dateStr,
    data: { date, hour }
  });

  const slotEvents = events.filter(e => {
    if (!e.start_time) return false;
    const eventHour = parseInt(e.start_time.split(':')[0]);
    return eventHour === hour;
  });

  return (
    <div
      ref={setNodeRef}
      className={`min-h-[60px] border-b border-r border-slate-100 p-1 transition-colors hover:bg-slate-50 ${
        isOver ? 'bg-blue-100 ring-1 ring-blue-400' : ''
      }`}
      onClick={() => onSlotClick(date, hour)}
    >
      {slotEvents.map(event => (
        <DraggableEvent key={event.event_id} event={event} onClick={onEventClick} compact />
      ))}
    </div>
  );
};

export const DayHourSlot = ({ date, hour, events, onEventClick, onSlotClick }) => {
  const dateStr = `day-${format(date, "yyyy-MM-dd")}-${hour}`;
  const { isOver, setNodeRef } = useDroppable({
    id: dateStr,
    data: { date, hour }
  });

  const slotEvents = events.filter(e => {
    if (!e.start_time) return false;
    const eventHour = parseInt(e.start_time.split(':')[0]);
    return eventHour === hour;
  });

  return (
    <div
      ref={setNodeRef}
      className={`min-h-[80px] border-b border-slate-100 p-2 transition-colors hover:bg-slate-50 ${
        isOver ? 'bg-blue-100 ring-1 ring-blue-400' : ''
      }`}
      onClick={() => onSlotClick(date, hour)}
    >
      <div className="space-y-1">
        {slotEvents.map(event => (
          <DraggableEvent key={event.event_id} event={event} onClick={onEventClick} />
        ))}
      </div>
    </div>
  );
};
